import vars from "../helpers";
import sliceText from "../components/slice-text";

const init = () => {
	const $awards = vars.$document.find('.awards');
	const $slider = document.querySelector('.awards-list');
	if ($awards.length) {
		sliceText.init($awards.find('.awards__text'), 320);
		new Swiper($slider, {
			slidesPerView: 3,
			slidesPerColumn: 2,
			spaceBetween: 30,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},

			breakpoints: {
				// when window width is >= 320px
				1: {
					slidesPerView: 1,
					slidesPerColumn: 1,
					spaceBetween: 0,
				},
				1025: {
					slidesPerView: 3,
					slidesPerColumn: 2,
					spaceBetween: 30,
				}
			}
		});

		console.log('unit')
	}
};

export default {
	init,
}
